
import { inAppRedirect } from '~/utils/route-redirects';

export default {
  name: 'NotificationMention',
  props: {
    notif: {
      required: true,
      type: Object,
    },
  },
  methods: {
    goToTarget(targetId) {
      inAppRedirect(`/post/${targetId}`);
    },
  },
};
